/**
 * 그리드 잠금 해제 확인 팝업의 미니맵 셀 분류 — 순수 로직(Phaser 비의존, 테스트 대상).
 * 색 매핑은 GridUnlockConfirmPopup(표현)이 소유 — 분류(상태)와 표현(색)을 분리한다.
 */

/** 미니맵 셀 표시 상태 — 대상(해제할 칸) / 모듈 설치됨 / 빈 해금칸 / 잠금. */
export type GridMiniCellState = "target" | "occupied" | "unlocked" | "locked";

/**
 * 우선순위 분류 — 대상 셀(해금 예정)이 최우선(잠금 여부 무관),
 * 그 다음 모듈 설치 셀(occupied), 그 외는 해금이면 unlocked·아니면 locked.
 * (대상 셀은 잠금 상태라 occupied일 수 없으나 우선순위는 명시 — target > occupied > unlocked > locked.)
 */
export function classifyGridMiniCell(
  x: number,
  y: number,
  targetX: number,
  targetY: number,
  isUnlocked: (x: number, y: number) => boolean,
  isOccupied: (x: number, y: number) => boolean,
): GridMiniCellState {
  if (x === targetX && y === targetY) return "target";
  if (isOccupied(x, y)) return "occupied";
  return isUnlocked(x, y) ? "unlocked" : "locked";
}
